import { i18n } from '@lingui/core';

export const ROUTE_PATH = '/admin/clients/new';
export const TITLE = i18n._('New Client');
